import { render, staticRenderFns } from "./PhoneLayout.vue?vue&type=template&id=fe7cb1dc&scoped=true&"
import script from "./PhoneLayout.vue?vue&type=script&lang=js&"
export * from "./PhoneLayout.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLayout.vue?vue&type=style&index=0&id=fe7cb1dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7cb1dc",
  null
  
)

export default component.exports